import { useEffect } from 'react';
import { createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider, useLocation } from 'react-router-dom';
import { configureApi } from './ApiConfig';
import './App.css';
import Chat from './components/pages/Chat';
import CreateListing from './components/pages/createlisting';
import LandingPage from './components/pages/LandingPage';
import Listing from './components/pages/Listing/Listing';
import ManageListings from './components/pages/ManageListings';
import SearchResults from './components/pages/SearchResults';
import CityDirectoryPage from './components/pages/CityDirectoryPage'

import { initGA, logPageView } from './util/Analytics';
import { AuthProvider, defaultApiClients } from './AuthContext';
import { UnreadMessagesProvider, UnreadMessagesUpdater } from './UnreadMessagesContext';
import { SignInModalProvider } from './SignInModalContext';
import NotFoundPage from './components/pages/NotFoundPage';

// Configure the API
configureApi();

function Layout() {
  const location = useLocation();

  useEffect(() => {
    initGA('G-2MS79K5FYM');
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });

    logPageView();

  }, [location]);

  return (
    <>
      <SignInModalProvider>
        <UnreadMessagesUpdater />
        <Outlet />
      </SignInModalProvider>
    </>
  );
}

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const erudaScript = document.createElement('script');
      erudaScript.src = 'https://cdn.jsdelivr.net/npm/eruda';
      erudaScript.async = true;
      erudaScript.onload = () => {
        // Initialize Eruda
        if (typeof window !== 'undefined' && (window as any).eruda) {
          (window as any).eruda.init();
        }
      };
      document.body.appendChild(erudaScript);

      return () => {
        document.body.removeChild(erudaScript);
      };
    }
  }, []);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />}>
        <Route index path="/" element={<LandingPage />} />
        <Route path="/create-listing" element={<CreateListing />} />
        <Route path="/share-house/:location/:features/:id" element={<Listing />} />
        <Route path="/listing/:slug?/:id" element={<Listing />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/manage-listings" element={<ManageListings />} />
        <Route path="/search-results" element={<SearchResults />} />

        <Route path="/sharehouses-in-sydney" element={<CityDirectoryPage cityKey="sydney" />} />
        <Route path="/sharehouses-in-melbourne" element={<CityDirectoryPage cityKey="melbourne" />} />
        <Route path="/sharehouses-in-brisbane" element={<CityDirectoryPage cityKey="brisbane" />} />
        <Route path="/sharehouses-in-perth" element={<CityDirectoryPage cityKey="perth" />} />
        <Route path="/sharehouses-in-goldcoast" element={<CityDirectoryPage cityKey="goldcoast" />} />
        <Route path="/sharehouses-in-adelaide" element={<CityDirectoryPage cityKey="adelaide" />} />
        <Route path="/sharehouses-in-canberra" element={<CityDirectoryPage cityKey="canberra" />} />
        <Route path="/sharehouses-in-newcastle" element={<CityDirectoryPage cityKey="newcastle" />} />
        <Route path="/sharehouses-in-hobart" element={<CityDirectoryPage cityKey="hobart" />} />
        <Route path="/sharehouses-in-darwin" element={<CityDirectoryPage cityKey="darwin" />} />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    )
  );

  return (
    <AuthProvider apiClients={defaultApiClients}>
      <UnreadMessagesProvider>
        <RouterProvider router={router} />
      </UnreadMessagesProvider>
    </AuthProvider>
  );
}

export default App;